$(document).ready(function () {
    $(".carousel-slick").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        arrows: false,
        variableWidth: true,
    });
});

$(document).ready(function () {
    $(".products-carousel").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: true, 
        prevArrow: '.prevButton', 
        nextArrow: '.nextButton', 
        variableWidth: false,
        appendArrows: '.buttons', 
        responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
      ] 
    });
});



$(document).ready(function () {
    $(".shops-carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
    });
});


